export default __webpack_public_path__ + "static/reed-4-47c366ff876696e5a74e746a9ac2f980.webp";